// Pure helpers for the live packet feed drawer (components/FeedDrawer.tsx); no imports so tests/feedDrawer.test.mjs
// can run it directly. On a wide screen the feed is a drawer on the map's right edge; on a phone it is a bottom sheet.

export const FEED_STORAGE_PREFIX = "amalgamesh:feedCollapsed";

/** The layout's own breakpoint (CSS 01-shell-map.css): at or below this width the side column becomes a bottom sheet. */
export const FEED_SHEET_QUERY = "(max-width: 860px)";

/** The localStorage key. The sheet and the drawer each remember their own choice. */
export function feedStorageKey(sheet: boolean): string {
  return sheet ? `${FEED_STORAGE_PREFIX}:sheet` : FEED_STORAGE_PREFIX;
}

/** Whether the feed is folded: the remembered choice ("1" folded, "0" open), otherwise open as a drawer, folded as a sheet. */
export function parseFeedCollapsed(stored: string | null | undefined, sheet: boolean): boolean {
  if (stored === "1") return true;
  if (stored === "0") return false;
  return sheet;
}

export function serializeFeedCollapsed(collapsed: boolean): string {
  return collapsed ? "1" : "0";
}

/** "Live packets" and the count, as the folded tab and the sheet bar show it. */
export function feedHandleLabel(count: number | null): string {
  return count === null ? "Live packets" : `Live packets (${count})`;
}

/** A finger's vertical travel on the sheet bar, in px (negative is up): tap, or drag up to open, drag down to fold. */
export const SHEET_DRAG_THRESHOLD_PX = 24;
export function sheetGesture(dy: number, collapsed: boolean): "toggle" | "expand" | "collapse" | "none" {
  if (Math.abs(dy) < SHEET_DRAG_THRESHOLD_PX) return "toggle";
  if (dy < 0) return collapsed ? "expand" : "none";
  return collapsed ? "none" : "collapse";
}
